import React, { createContext, useContext, useMemo } from "react";
import {
	getDeploymentLineLegalPublisher,
	type DeploymentLineLegalPublisher,
} from "le-coffre-resources/dist/deploymentLineLegalPublisher";
import { normalizeDeploymentSiteCodeForPublicWeb } from "le-coffre-resources/dist/deploymentSitePublicWeb";
import { getPublicSiteCode } from "@Front/themes/siteTheme";

const DeploymentLineLegalPublisherReactContext = createContext<DeploymentLineLegalPublisher | null>(null);

export function DeploymentLineLegalPublisherProvider(props: { children: React.ReactNode }): React.JSX.Element {
	const value = useMemo(
		() => getDeploymentLineLegalPublisher(normalizeDeploymentSiteCodeForPublicWeb(getPublicSiteCode())),
		[],
	);
	return (
		<DeploymentLineLegalPublisherReactContext.Provider value={value}>
			{props.children}
		</DeploymentLineLegalPublisherReactContext.Provider>
	);
}

export function useDeploymentLineLegalPublisher(): DeploymentLineLegalPublisher {
	const ctx = useContext(DeploymentLineLegalPublisherReactContext);
	if (!ctx) {
		throw new Error("useDeploymentLineLegalPublisher must be used within DeploymentLineLegalPublisherProvider");
	}
	return ctx;
}
